export default __webpack_public_path__ + "static/media/sports1.a9018abf.jpg";